export async function useFetchCustomerData() {
  const { appAuthorizationHeader } = useAppAuthorizationHeader()

  const { data, error, refresh } = await useFetch('/customer/data', {
    server: false,
    method: 'GET',
    credentials: 'include',
    headers: {
      ...(appAuthorizationHeader && appAuthorizationHeader),
    },
    baseURL: useRuntimeConfig().public.apiBaseURL,
    query: {
      client: useRuntimeConfig().public.client,
    },
    transform: (response: any) => {
      return response.data
    },
  })

  if (error.value) {
    await fetchRefreshToken()
    await refresh()
  }
  return data
}
